import React from "react";
import { RichText } from "prismic-reactjs";
import Prismic from "prismic-javascript";
import NotFound from "./NotFound";
import Loader from "./Loader";

export default class FocusAreas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notFound: false,
      list: []
    };
    if (props.prismicCtx) {
      this.fetchList(props);
    }
  }

  componentDidUpdate(prevProps) {
    // this.props.prismicCtx.toolbar();
    if (!prevProps.prismicCtx) {
      this.fetchList(this.props);
    }
  }

  fetchList(props) {
    return props.prismicCtx.api
      .query(
        // Get the blog posts in descending order
        Prismic.Predicates.at("document.type", "focus_area")
      )
      .then(res => {
        const list = res.results.sort((a, b) => {
          return a.data.order - b.data.order;
        });
        this.setState({ list: list });
      });
  }

  listSection() {
    return (
      <div className="row">
        {this.state.list.map(item => {
          return (
            <div className="col-12 col-md-6 col-lg-4 mb-4" key={item.id}>
              <div className="focus-area-item">
              <a href={this.props.prismicCtx.linkResolver(item)}>
                <img
                  src={item.data.main_image.url}
                  alt=""
                  className="btn-block mb-2"
                />
                <p className="font-weight-bold text-uppercase mb-1 px-2">
                  {item.data.title.length !== 0 && RichText.asText(
                    item.data.title,
                    this.props.prismicCtx.linkResolver
                  )}
                </p>
                </a>
                <p className="px-2 mb-2">
                  {RichText.asText(
                    item.data.description,
                    this.props.prismicCtx.linkResolver
                  )}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    if (this.state.list.length > 0) {
      return (
        <div className="pt-5 pb-5">
          <h2 className="mb-4 text-uppercase">Focus Areas</h2>
          {this.listSection()}
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/FocusAreas.js